<template>
  <v-application v-if="access.setting_nds">
    <v-settings>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t("nds_settings") }}</v-toolbar-title>
      </v-toolbar>
      <v-form v-model="is_valid">
        <v-card-text>
          <v-text-field
            v-model.number="nds.value"
            v-bind:max="100"
            type="number"
            :label="$t('a_percentage_of_the_nds')"
            :rules="[fieldRules.requiredNumber, fieldRules.percent]"
          />
        </v-card-text>
      </v-form>
      <template #actions>
        <v-btn text v-on:click="get_nds">{{ $t("cancel") }}</v-btn>
        <v-btn
          text
          color="primary"
          :loading="loading_nds_settings"
          v-on:click="update_nds"
          :disabled="!is_valid"
          >{{ $t("save") }}</v-btn
        >
      </template>
    </v-settings>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import NDS from "../../mixins/settings/NDS";
export default {
  name: "SettingsNDS",
  mixins: [NDS],
  data: () => ({
    is_valid: false,
    loading_nds_settings: false,
  }),
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>